export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
// "true" = always noindex; "false" = follow the site setting; "audit" = local Lighthouse test build only (never noindex)
export const NOINDEX_MODE = process.env.REACT_APP_NOINDEX;
export const NOINDEX = NOINDEX_MODE === "true";
export const LANG = "tr";
// Indexable only on the canonical domain (and its www alias); preview/deploy hosts stay noindex
export const onProdHost = () => {
  if (!SITE_URL || typeof window === "undefined") return false;
  const h = new URL(SITE_URL).hostname.replace(/^www\./, "");
  return [h, `www.${h}`].includes(window.location.hostname);
};
